import React from 'react';
import { FaCalendarDay, FaUserFriends, FaPhoneAlt, FaEnvelope, FaClock } from 'react-icons/fa';
import SectionTextMaybe from '../../containers/ListingPage/SectionTextMaybe';
import css from './SectionTextWithIcons.module.css';

// Add new keys for start and end grooming times
const iconMap = {
  drop_off_window: <FaCalendarDay />,
  pick_up_window: <FaCalendarDay />,
  emergency_contact_name: <FaUserFriends />,
  relationship: <FaUserFriends />,
  emergency_phone_number: <FaPhoneAlt />,
  alternate_email: <FaEnvelope />,
  start_time_grooming: <FaClock />,
  end_time_grooming: <FaClock />,
};

const SectionTextWithIcons = props => {
  const { fieldKey } = props;
  const icon = iconMap[fieldKey];

  return icon ? (
    <div style={{ display: 'flex', columnGap: '8px' }} className={css.root}>
      <span style={{ display: 'inline-block' }} className={css.facilityIcon}>
        {icon}
      </span>
      <SectionTextMaybe {...props} style={{ padding: '0' }} />
    </div>
  ) : (
    <SectionTextMaybe {...props} />
  );
};

export default SectionTextWithIcons;
